import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './lucezarepersonal_antesdepois.module.scss';

/** Ordem natural 1–6 (evita sort alfabético 1, 10, 2…) */
const GALLERY_ITEMS: { src: string; label: string }[] = [
    { src: require('./src/antesdepois/antesdepois1.png'), label: '01' },
    { src: require('./src/antesdepois/antesdepois2.png'), label: '02' },
    { src: require('./src/antesdepois/antesdepois3.png'), label: '03' },
    { src: require('./src/antesdepois/antesdepois4.png'), label: '04' },
];

const Lucezarepersonal_antesdepois: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.lucezarepersonal_antesdepois}>
            <div className={styles.page}>
                <div className={styles.header}>
                    <Link
                        to="/lucezarepersonal"
                        state={{ skipLoader: true }}
                        className={styles.backButton}
                        aria-label="Voltar ao link na bio"
                    >
                        <FaArrowLeft />
                    </Link>
                    <div className={styles.headerText}>
                        <p className={styles.eyebrow}>Luciana Cezare</p>
                        <h1 className={styles.title}>Antes e depois</h1>
                    </div>
                </div>

                <p className={styles.intro}>
                    Aqui estão alguns antes e depois que traduzem constância, evolução e resultado. Cada processo é
                    individual, com estratégia, acompanhamento e foco no objetivo de cada aluno.
                </p>

                <div className={styles.grid}>
                    {GALLERY_ITEMS.map((item, index) => (
                        <figure key={item.src} className={styles.card}>
                            <img
                                src={item.src}
                                alt={`Antes e depois - Luciana Cezare, resultado ${item.label}`}
                                className={styles.cardImage}
                                loading={index < 2 ? 'eager' : 'lazy'}
                            />
                            <figcaption className={styles.cardFigcaption}>{item.label}</figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Lucezarepersonal_antesdepois;
